import React, { useEffect } from "react";
import Head from "next/head";
import type { NextPage } from "next";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";

import RemaxFranchise from "@components-pages/franquicias/RemaxFranchise";
import Benefits from "@components-pages/franquicias/Benefits";
import OurLocation from "@components-pages/franquicias/OurLocation";
import ObtainYourFranchise from "@components-pages/franquicias/ObtainYourFranchise";
import { useTranslations } from "next-intl";
import createCanonicalUrl from "@helpers/removeparams";
import WsPhantomNav from "@components/a1-refactor/typography/WsPhantomNav";

const Franquicias: NextPage = (props: any) => {
  const router = useRouter();
  const titleT = useTranslations("title-pages");

  useEffect(() => {
    const hash = props.hash;
    if (hash) {
      const anchor = document.querySelector("#" + hash);

      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [props.hash]);

  const metaData = {
    description:
      "Remax es la red inmobiliaria #1 a nivel mundial, con más de 138 mil agentes, distribuidos en 110 países.",
    keyWords:
      "Franquicia Remax, franquicia inmobiliaria, adquirir franquicia inmobiliaria, Franquicias inmobiliarias Remax República Dominicana, adquirir franquicia en remax rd",
    title: titleT("franchise"),
    url: process.env.NEXT_PUBLIC_DOMAIN_URL + router.asPath,
    image:
      process.env.NEXT_PUBLIC_DOMAIN_URL +
      "/images/image-optimize/two-smiling-clerk-businessmen-deliberate-on-problem_1.webp",
  };

  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
        <meta name="keywords" content={metaData.keyWords} />
        <meta property="og:url" content={metaData.url} />
        <meta property="og:title" content={metaData.title} />
        <meta property="og:image" content={metaData.image} />
        <link
          rel="canonical"
          href={createCanonicalUrl(
            process.env.NEXT_PUBLIC_DOMAIN_URL + router.asPath
          )}
          key="canonical"
        />
      </Head>
      <RemaxFranchise />
      <Benefits />
      <OurLocation />
      <ObtainYourFranchise />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  /* @ts-ignore */
  const hash = (context.query.to as string) || null;
  const locale = context.locale;

  return {
    props: {
      hash: hash,
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
};

export default Franquicias;
